"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Input_1 = __importDefault(require("shared/components/Input/Input"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var hooks_1 = require("utils/hooks");
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var ordered_1 = require("utils/selectors/ordered");
var Tool_1 = __importDefault(require("./Tool"));
var Wrapper = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: 1000,
        margin: theme.spacing(0, 'auto', 2, 'auto'),
        padding: theme.spacing(1, 6, 4, 6), // 8 48 32 48
    });
});
var GridItem = (0, styles_1.styled)(material_1.Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(3),
        flexBasis: 'auto',
        borderRadius: 6,
        ':focus-visible': __assign({}, theme.focusVisibleStyles),
    });
});
var DEALS_PER_PAGE = 9;
var Deals = function () {
    var _a = __read((0, hooks_1.useSearch)(), 2), searchText = _a[0], setSearchText = _a[1];
    var dealCategory = (0, react_router_dom_1.useParams)().dealCategory;
    var servicesWithDeals = (0, react_redux_1.useSelector)((0, ordered_1.makeSelectServicesWithDeals)(dealCategory));
    var filteredServicesWithDeals = (0, orderBy_1.default)(servicesWithDeals === null || servicesWithDeals === void 0 ? void 0 : servicesWithDeals.filter(function (service) { var _a; return (_a = service.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLocaleLowerCase()); }), function (s) { var _a; return (_a = s.transactionsCount) !== null && _a !== void 0 ? _a : 0; }, 'desc');
    var _b = __read((0, useInfiniteScroll_1.default)(filteredServicesWithDeals || [], DEALS_PER_PAGE), 2), dealsList = _b[0], loaderRef = _b[1];
    var trackDealsSearched = (0, analytics_1.usePreparedTracker)('Deals Searched');
    react_1.default.useEffect(function () {
        trackDealsSearched({
            searchText: searchText,
            dealsList: (dealsList === null || dealsList === void 0 ? void 0 : dealsList.map(function (s) { return s.name; })) || [],
            filteredServicesWithDeals: (filteredServicesWithDeals === null || filteredServicesWithDeals === void 0 ? void 0 : filteredServicesWithDeals.map(function (s) { return s.name; })) || [],
        });
    }, [searchText]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Tools", description: "Discover SaaS tools" }), (0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, mb: 6 }, { children: "Discover SaaS Tools" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mb: 6 }, { children: "Explore and find the right software products from the best vendors. Find exclusive deals for your favorite tools." })), (0, jsx_runtime_1.jsx)(Input_1.default, { type: "search", placeholder: "Search...", value: searchText, fullWidth: true, onChange: function (event) { return setSearchText(event.target.value); }, variant: "filled" }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mt: 6, mb: 4 }, { children: "SaaS Tools" })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 2, ml: -4 }, { children: [dealsList === null || dealsList === void 0 ? void 0 : dealsList.map(function (deal) { return ((0, jsx_runtime_1.jsx)(GridItem, __assign({ item: true, xs: 4 }, { children: (0, jsx_runtime_1.jsx)(Tool_1.default, { service: deal }) }), deal.id)); }), (0, jsx_runtime_1.jsx)("div", { ref: loaderRef })] }))] }) }) }))] }));
};
exports.default = Deals;
